import { useAuthStore } from "../stores/auth";

/**
 * Returns true if the current user has the specified role in the given app.
 * Use for UI gating only — real enforcement is always at the database via RLS.
 */
export function useHasRole(app: string, role: string | string[]): boolean {
  const appRoles = useAuthStore((state) => state.appRoles);
  const roles = Array.isArray(role) ? role : [role];
  return appRoles.some((r) => r.app === app && roles.includes(r.role));
}

export function useHasAnyRole(app: string, roles: string[]): boolean {
  const appRoles = useAuthStore((state) => state.appRoles);
  return appRoles.some((r) => r.app === app && roles.includes(r.role));
}

export function useTerritoryIds(): string[] {
  return useAuthStore((state) => state.territoryIds);
}
